import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import { vuexfireMutations, firestoreAction } from "vuexfire";
import firestore from "@/firebase/firestore";

import Menu from "@/model/menu";

export const addProduct = "addProduct";
export const deleteProduct = "deleteProduct";
export const getMenu = "getMenu";
export const setMenu = "setMenu";
export const newOrder = "newOrder";

Vue.use(Vuex);

// const RESTAURANT_ID = "RfdcYtKZecyoBQHPGSBh";
// const CUSTOMER_ID = "WkKnBaXzNFcqAZ4PyMExk6ITk4M2";

const store = new Vuex.Store({
  plugins: [new VuexPersistence().plugin],
  state: {
    _menu: null,
    notifications: {},
    // _customer: [],
    pastOrders: [],
    selectedProduct: null,
    locationCode: null,
    location: null,
    // _locationObject: null,
    restaurantId: null,
    _uid: null,
    cookiesAcepted: false,
    _orders: [],
    session: null,
    notifyToken: false
  },
  mutations: {
    ...vuexfireMutations,
    set(state, data) {
      Vue.set(state, data.varName, data.value);
    }
  },

  actions: {
    // TODO Load from locationCode
    bindMenu: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        "_menu",
        firestore.doc(`/menus/${store.state.restaurantId}`)
      );
    }),
    // bindCustomer: firestoreAction(({ bindFirestoreRef }) => {

    //   return bindFirestoreRef(
    //     "_customer",
    //     firestore.doc(`/customers/${store.state._uid}`)
    //   );
    // }),
    bindOrders: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        "_orders",
        firestore
          .collection(`/restaurants/${store.state.restaurantId}/orders/`)
          .where("userId", "==", store.state._uid)
          .where("session", "==", store.state.session)
        // .where(
        //   "date",
        //   ">",
        //   new Date(new Date().setDate(new Date().getDate() - 1)) //Only last day
        // )
      );
    }),
    bindLocation: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        "_locationObject",
        firestore.doc(
          `/restaurants/${store.state.restaurantId}/locations/${store.state.location}`
        )
      );
    })
  },

  getters: {
    menu: state => (state._menu ? Menu.fromMap(state._menu) : null),
    hasPreviousOrders: state => (state._orders.length > 0 ? true : false),
    hasPreviousOrdersPaid: (state, getters) => {
      let paid = true;
      store.state._orders.forEach(order => {
        paid = order.hasBeenPaid ? paid : order.hasBeenPaid;
      });
      return paid & !!getters.hasPreviousOrders;
    },
    isReady: (_, getters) => !!getters.menu,
    canOrder: (state, getters) => {
      return state._locationObject ? state._locationObject.canOrder : false;
    },
    isNotified: state => {
      return !!state._locationObject.isNotified;
    },
    notifyToken: state => {
      return state.notifyToken;
    }
  }
});

export default store;
